import { Outlet, Link, useNavigate } from "react-router-dom";
import { Fragment, useState } from "react";
import { HiOutlineXMark } from "react-icons/hi2";
import { VscMenu } from "react-icons/vsc";
import { ReactComponent as LogoIcon } from "../../asset/Frame logo.svg";
import { ReactComponent as PersonIcon } from "../../asset/bi_person.svg";
import { MdOutlineArrowDropDown } from "react-icons/md";
import { IoHomeOutline, IoLogOutOutline } from "react-icons/io5";
import { TbClipboardList } from "react-icons/tb";
import { MdAssignmentTurnedIn } from "react-icons/md";
import { FaRegUser } from "react-icons/fa6";
import UserDataFetcher from "../../super_admin/libs/Getadminbyid";
import { AuthContext } from "../../Context/AuthContext";
import { useContext } from "react";
import "./Ridernavbar.css";

function Ridernavbar() {
  const { adminData } = UserDataFetcher();

  const [isMobile, setIsmobile] = useState(false);
  const { Logout } = useContext(AuthContext);
  const navigate = useNavigate();
  return (
    <Fragment>
      <div className="navbar-container-account">
        <div className="logo">
          <LogoIcon onClick={() => navigate("/")} />
          <span>
            Welcome back,{" "}
            <p>
              {adminData?.user?.first_name} {adminData?.user?.last_name}
            </p>
          </span>
        </div>

        <div className="drop">
          <div className="ic">
            <PersonIcon />
          </div>
          <MdOutlineArrowDropDown className="arrow" />
        </div>
        <div className="menubtn" onClick={() => setIsmobile(!isMobile)}>
          {isMobile ? <HiOutlineXMark /> : <VscMenu />}
        </div>
        <div
          className={`nav-links ${isMobile ? "mobile-link active" : ""}`}
          onClick={() => setIsmobile(!isMobile)}
        >
          <Link to="/">
            <IoHomeOutline className="nav-icon" /> Home
          </Link>
          <Link to="/Rideraccepted">
            <TbClipboardList className="nav-icon" /> My assignment
          </Link>
          <Link to="/Riderclosedassignment">
            <MdAssignmentTurnedIn className="nav-icon" /> Closed assignment
          </Link>
          <Link to="/Riderprofile">
            <FaRegUser className="nav-icon" /> Profile
          </Link>
          <button onClick={() => Logout()}>
            <IoLogOutOutline className="nav-icon logout-icon" /> Logout
          </button>
        </div>
      </div>
      <Outlet />
    </Fragment>
  );
}

export default Ridernavbar;
